import plans from "@storage/app/plans.json";
import plansFeatures from "@storage/app/plansFeatures.json";

export const FEATURE_DOCUMENT_UPDATE = "documents.update";

export const planByName = (planName, plansList = null) =>
    (plansList || plans).find(({ name }) => name === planName);

export const planBySlug = (planSlug, plansList = null) =>
    (plansList || plans).find(({ slug }) => slug === planSlug);

export const plansByLocale = (planLocale) =>
    plans.filter(({ locale }) => locale.includes(planLocale));

export const planFeaturesCount = (plan, featureStatus = "success") =>
    plan?.displayed_features?.filter(({ status }) => status === featureStatus)
        .length || 0;

export const planHasFeatures = (plan, features = []) => {
    return features.reduce(
        (current, requiredFeature) =>
            current &&
            !!plan?.features.find(({ slug }) => slug === requiredFeature),
        true
    );
};

// Returns array of plans which has at least one one-time-pay price point
export const oneTimePlans = (planLocale = "en", planList = null) => {
    const plansForSearch = planList?.length > 0 ? planList : plans;

    return plansForSearch.filter(({ locale, prices }) => {
        if (planLocale && !locale.includes(planLocale)) {
            return false;
        }

        return !!prices.find(({ billing_period }) =>
            billing_period.match(/^one-time-\d+/)
        );
    });
};

// Returns array of plans which has at least one subscription price point
export const subscriptionPlans = (
    planLocale = "en",
    planList = null,
    selectFromAll = true
) => {
    const plansForSearch =
        planList?.length > 0 ? planList : selectFromAll ? plans : [];

    return plansForSearch.filter(({ locale, prices }) => {
        if (planLocale && !locale.includes(planLocale)) {
            return false;
        }

        return !!prices.find(
            ({ billing_period }) => !billing_period.match(/^one-time-\d+/)
        );
    });
};

export const getPlanFeatures = (planLocale = "en") =>
    plansFeatures.find(({ locale }) => locale === planLocale)?.features;

export const getPricingById = (stripeId) =>
    plans
        .map(({ prices }) =>
            prices.find(
                ({ stripe_price_id, paypal_price_id }) =>
                    stripeId === stripe_price_id || stripeId === paypal_price_id
            )
        )
        .filter((p) => p)
        .pop();
